<template>
  <div class="section-sub-title">{{ text }}</div>
</template>

<script>
export default {
  name: 'SectionSubTitle',
  props: {
    text: {
      type: String,
      default: 'Personal Details'
    }
  }
}
</script>

<style scoped>
.section-sub-title {
  color: var(--Basic-900, #091540);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
}
</style>
